import { useI18n } from 'vue-i18n'

import useBlProviders from '../providers/useBlProvider'
import StaffRolesDt from '@/services/dataTransferModules/staffRolesDt'

export default function useStaffRoles(params = {}) {
	const staffRolesDt = new StaffRolesDt()

	const { t: $t } = useI18n()

	const defaults = {
		creatingStaffRole: {
			name: '',
		},
		fieldsToPatch: ['name'],
	}

	const {
		loadEntityFlags: flags,

		entities: staffRoles,
		getEntities: getStaffRoles,

		createEntity: createStaffRoles,

		entity: staffRole,
		getEntity: getStaffRole,

		patchEntity: updateStaffRoles,
		updateEntity: fullUpdateStaffRoles,

		deleteEntity: deleteStaffRoles,
	} = useBlProviders(
		staffRolesDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Employee role loading with error'),

				showErrorNotificationForCreatingEntity: true,

				showErrorNotificationForLoadingOneEntity: true,

				showErrorNotificationForUpdatingEntity: true,
				errorNotificationTextForUpdatingEntity: $t('Error when editing an employee`s role'),

				showErrorNotificationForDeletingEntity: true,
			},
			params,
		),
	)

	return {
		flags,
		staffRoles,
		staffRole,
		defaults,
		getStaffRoles,
		getStaffRole,
		createStaffRoles,
		deleteStaffRoles,
		updateStaffRoles,
		fullUpdateStaffRoles,
	}
}
